import { ref } from 'vue'

const loaded = ref(false)
const loading = ref(false)
const error = ref<Error | null>(null)

export function useStorePreloader() {
  const loadAllData = async (isAdmin = false) => {
    // Skip if already loaded or currently loading
    if (loaded.value || loading.value) return

    // If not admin, don't load all data
    if (!isAdmin) return

    try {
      loading.value = true
      error.value = null

      // Get store instances
      const membersStore = useMembersStore()
      const subkrewesStore = useSubKrewesStore()

      // Load subkrewes FIRST so member.subkrewe resolution uses cached data
      // This prevents N individual fetches when resolving subkrewe references
      await subkrewesStore.fetchSubKrewes()

      // Now load members - subkrewe resolution will use cache
      await membersStore.fetchMembers()

      loaded.value = true
    }
    catch (err) {
      error.value = err instanceof Error ? err : new Error(String(err))
      console.error('Error loading all data:', error.value)
    }
    finally {
      loading.value = false
    }
  }

  return {
    loaded,
    loading,
    error,
    loadAllData,
  }
}
